<template>
  <div class="row">
    <!-- Search bar -->
    <div v-if="showSearchBar" class="col-12">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-lg-2 col-md-6">
              <div class="input-group">
                <input
                  class="form-control"
                  placeholder="Name"
                  type="text"
                  @input="searchField('name', $event.target.value)"
                />
              </div>
            </div>
            <div class="col-lg-2 col-md-6 ms-auto">
              <a
                class="btn btn-sm btn-primary btn-block"
                href="javascript:void(0);"
                title=""
                >Search</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="table-responsive">
        <table
          class="table table-hover table-custom dataTable machinery-makers-js-data-table"
        >
          <thead>
            <tr>
              <th>Name</th>
              <th>Address</th>
              <th>City</th>
              <th>Country</th>
              <th>P.Code</th>
              <th>Associated Vessels</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(machineryMaker, index) in filteredMakers()"
              :key="index"
            >
              <td>
                <a href="#" @click="makerClicked(machineryMaker)">{{
                  machineryMaker.name
                }}</a>
              </td>
              <td>
                <a @click="makerClicked(machineryMaker)"
                  >{{ machineryMaker.line1 }} {{ machineryMaker.line2 }}</a
                >
              </td>
              <td>
                <a @click="makerClicked(machineryMaker)">{{
                  machineryMaker.city
                }}</a>
              </td>
              <td>
                <a @click="makerClicked(machineryMaker)">{{
                  machineryMaker.country
                }}</a>
              </td>
              <td>
                <a @click="makerClicked(machineryMaker)">{{
                  machineryMaker.postcode
                }}</a>
              </td>
              <td>{{ associatedVessels(machineryMaker) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MachineryMakersTable",
  props: {
    machineryMakers: {
      type: Array,
      default: () => [],
    },
    showSearchBar: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fieldFilters: [],
    };
  },
  methods: {
    getMakerObjectFromListObject(makerFromList) {
      let maker = {
        id: makerFromList.id,
        name: makerFromList.name,
      };

      let address = { ...makerFromList };
      address.id = address.address_id;
      delete address.address_id;
      delete address.associated_vessels;
      delete address.name;

      maker.address = address;

      return maker;
    },
    makerClicked(maker) {
      let resolvedRoute = this.$router.resolve({
        name: "machinery-makers-edit",
        params: { makerId: maker.machinery_maker_id },
      });
      window.open(resolvedRoute.href, "_blank", "noreferrer");
    },
    searchField: function (field, searchString) {
      let elem = this.fieldFilters.find((f) => f.field === field);
      if (elem !== undefined) {
        elem.searchString = searchString;
      } else {
        this.fieldFilters.push({
          field,
          searchString,
        });
      }
    },
    filteredMakers: function () {
      let result = [...this.machineryMakers];
      this.fieldFilters.forEach((element) => {
        if (element.searchString) {
          result = result.filter((v) =>
            v?.[element.field]
              ?.toLowerCase()
              ?.includes(element.searchString.toLowerCase())
          );
        }
      });
      return result;
    },
    associatedVessels: function (machineryMaker) {
      return machineryMaker.associated_vessels;
    },
    buildDataTable() {
      if (this.table) this.table.destroy();
      setTimeout(() => {
        this.table = window.jsDataTable(".machinery-makers-js-data-table");
      }, 250); // Just giving Vue some time to render the table
    },
  },
  mounted() {
    this.buildDataTable();
  },
  watch: {
    machineryMakers() {
      this.buildDataTable();
    },
  },
};
</script>
